//UPDATE_COMPANY
export const UPDATE_RECRUITMENT_COMPANY_REQUEST =
  "UPDATE_RECRUITMENT_COMPANY_REQUEST";
export const UPDATE_RECRUITMENT_COMPANY_SUCCESS =
  "UPDATE_RECRUITMENT_COMPANY_SUCCESS";
export const UPDATE_RECRUITMENT_COMPANY_FAIL =
  "UPDATE_RECRUITMENT_COMPANY_FAIL";

//UPDATE_JOB_AD_DETAILS
export const UPDATE_JOB_AD_DETAILS_REQUEST = "UPDATE_JOB_AD_DETAILS_REQUEST";
export const UPDATE_JOB_AD_DETAILS_SUCCESS = "UPDATE_JOB_AD_DETAILS_SUCCESS";
export const UPDATE_JOB_AD_DETAILS_FAIL = "UPDATE_JOB_AD_DETAILS_FAIL";

//ADD_JOB_POST_ID
export const ADD_JOB_POST_ID_REQUEST = "ADD_JOB_POST_ID_REQUEST";
export const ADD_JOB_POST_ID_SUCCESS = "ADD_JOB_POST_ID_SUCCESS";
export const ADD_JOB_POST_ID_FAIL = "ADD_JOB_POST_ID_FAIL";

//UPLOAD_CANDIDATE_CVS
export const UPLOAD_CANDIDATE_CVS_REQUEST = "UPLOAD_CANDIDATE_CVS_REQUEST";
export const UPLOAD_CANDIDATE_CVS_SUCCESS = "UPLOAD_CANDIDATE_CVS_SUCCESS";
export const UPLOAD_CANDIDATE_CVS_FAIL = "UPLOAD_CANDIDATE_CVS_FAIL";

//UPLOAD_CANDIDATE_CVS_PARSING
export const UPLOAD_CANDIDATE_CVS_PARSING_REQUEST =
  "UPLOAD_CANDIDATE_CVS_PARSING_REQUEST";
export const UPLOAD_CANDIDATE_CVS_PARSING_SUCCESS =
  "UPLOAD_CANDIDATE_CVS_PARSING_SUCCESS";
export const UPLOAD_CANDIDATE_CVS_PARSING_FAIL =
  "UPLOAD_CANDIDATE_CVS_PARSING_FAIL";

//UPDATE_JOB_AD_APPLICATION
export const UPDATE_JOB_AD_APPLICATION_REQUEST =
  "UPDATE_JOB_AD_APPLICATION_REQUEST";
export const UPDATE_JOB_AD_APPLICATION_SUCCESS =
  "UPDATE_JOB_AD_APPLICATION_SUCCESS";
export const UPDATE_JOB_AD_APPLICATION_FAIL = "UPDATE_JOB_AD_APPLICATION_FAIL";

//UPDATE_JOB_AD_RECRUITER_ASSESSMENT
export const UPDATE_JOB_AD_RECRUITER_ASSESSMENT_REQUEST =
  "UPDATE_JOB_AD_RECRUITER_ASSESSMENT_REQUEST";
export const UPDATE_JOB_AD_RECRUITER_ASSESSMENT_SUCCESS =
  "UPDATE_JOB_AD_RECRUITER_ASSESSMENT_SUCCESS";
export const UPDATE_JOB_AD_RECRUITER_ASSESSMENT_FAIL =
  "UPDATE_JOB_AD_RECRUITER_ASSESSMENT_FAIL";

//UPDATE_JOB_AD_CANDIDATE_RECRUITER_ASSESSMENT
export const UPDATE_JOB_AD_CANDIDATE_RECRUITER_ASSESSMENT_REQUEST =
  "UPDATE_JOB_AD_CANDIDATE_RECRUITER_ASSESSMENT_REQUEST";
export const UPDATE_JOB_AD_CANDIDATE_RECRUITER_ASSESSMENT_SUCCESS =
  "UPDATE_JOB_AD_CANDIDATE_RECRUITER_ASSESSMENT_SUCCESS";
export const UPDATE_JOB_AD_CANDIDATE_RECRUITER_ASSESSMENT_FAIL =
  "UPDATE_JOB_AD_CANDIDATE_RECRUITER_ASSESSMENT_FAIL";

//UPDATE_JOB_AD_WORKFLOW
export const UPDATE_JOB_AD_WORKFLOW_REQUEST = "UPDATE_JOB_AD_WORKFLOW_REQUEST";
export const UPDATE_JOB_AD_WORKFLOW_SUCCESS = "UPDATE_JOB_AD_WORKFLOW_SUCCESS";
export const UPDATE_JOB_AD_WORKFLOW_FAIL = "UPDATE_JOB_AD_WORKFLOW_FAIL";

//UPDATE_JOB_AD_STATUS
export const UPDATE_JOB_AD_STATUS_REQUEST = "UPDATE_JOB_AD_STATUS_REQUEST";
export const UPDATE_JOB_AD_STATUS_SUCCESS = "UPDATE_JOB_AD_STATUS_SUCCESS";
export const UPDATE_JOB_AD_STATUS_FAIL = "UPDATE_JOB_AD_STATUS_FAIL";

//DUPLICATE_JOB_AD
export const DUPLICATE_JOB_AD_REQUEST = "DUPLICATE_JOB_AD_REQUEST";
export const DUPLICATE_JOB_AD_SUCCESS = "DUPLICATE_JOB_AD_SUCCESS";
export const DUPLICATE_JOB_AD_FAIL = "DUPLICATE_JOB_AD_FAIL";

//DELETE_JOB_AD
export const DELETE_JOB_AD_REQUEST = "DELETE_JOB_AD_REQUEST";
export const DELETE_JOB_AD_SUCCESS = "DELETE_JOB_AD_SUCCESS";
export const DELETE_JOB_AD_FAIL = "DELETE_JOB_AD_FAIL";

//GET_JOB_AD
export const GET_JOB_AD_REQUEST = "GET_JOB_AD_REQUEST";
export const GET_JOB_AD_SUCCESS = "GET_JOB_AD_SUCCESS";
export const GET_JOB_AD_FAIL = "GET_JOB_AD_FAIL";

//GET_ALL_JOB_AD
export const GET_ALL_JOB_AD_REQUEST = "GET_ALL_JOB_AD_REQUEST";
export const GET_ALL_JOB_AD_SUCCESS = "GET_ALL_JOB_AD_SUCCESS";
export const GET_ALL_JOB_AD_FAIL = "GET_ALL_JOB_AD_FAIL";

//GET_PAGINATED_JOB_AD
export const GET_PAGINATED_JOB_AD_REQUEST = "GET_PAGINATED_JOB_AD_REQUEST";
export const GET_PAGINATED_JOB_AD_SUCCESS = "GET_PAGINATED_JOB_AD_SUCCESS";
export const GET_PAGINATED_JOB_AD_FAIL = "GET_PAGINATED_JOB_AD_FAIL";

//GET_PAGINATED_JOB_FILTERS
export const GET_PAGINATED_JOB_FILTERS_REQUEST =
  "GET_PAGINATED_JOB_FILTERS_REQUEST";
export const GET_PAGINATED_JOB_FILTERS_SUCCESS =
  "GET_PAGINATED_JOB_FILTERS_SUCCESS";
export const GET_PAGINATED_JOB_FILTERS_FAIL = "GET_PAGINATED_JOB_FILTERS_FAIL";

//GET_KANBAN_DATA
export const GET_KANBAN_DATA_REQUEST = "GET_KANBAN_DATA_REQUEST";
export const GET_KANBAN_DATA_SUCCESS = "GET_KANBAN_DATA_SUCCESS";
export const GET_KANBAN_DATA_FAIL = "GET_KANBAN_DATA_FAIL";

//GET_ALL_JOB_AD_DETAILS
export const GET_ALL_JOB_AD_DETAILS_REQUEST = "GET_ALL_JOB_AD_DETAILS_REQUEST";
export const GET_ALL_JOB_AD_DETAILS_SUCCESS = "GET_ALL_JOB_AD_DETAILS_SUCCESS";
export const GET_ALL_JOB_AD_DETAILS_FAIL = "GET_ALL_JOB_AD_DETAILS_FAIL";

//GET_JOB_AD_DETAILS
export const GET_JOB_AD_DETAILS_REQUEST = "GET_JOB_AD_DETAILS_REQUEST";
export const GET_JOB_AD_DETAILS_SUCCESS = "GET_JOB_AD_DETAILS_SUCCESS";
export const GET_JOB_AD_DETAILS_FAIL = "GET_JOB_AD_DETAILS_FAIL";

//GET_JOB_AD_APPLICATION
export const GET_JOB_AD_APPLICATION_REQUEST = "GET_JOB_AD_APPLICATION_REQUEST";
export const GET_JOB_AD_APPLICATION_SUCCESS = "GET_JOB_AD_APPLICATION_SUCCESS";
export const GET_JOB_AD_APPLICATION_FAIL = "GET_JOB_AD_APPLICATION_FAIL";

//GET_JOB_AD_WORKFLOW
export const GET_JOB_AD_WORKFLOW_REQUEST = "GET_JOB_AD_WORKFLOW_REQUEST";
export const GET_JOB_AD_WORKFLOW_SUCCESS = "GET_JOB_AD_WORKFLOW_SUCCESS";
export const GET_JOB_AD_WORKFLOW_FAIL = "GET_JOB_AD_WORKFLOW_FAIL";

//GET_ALL_COMPANIES
export const GET_ALL_COMPANIES_REQUEST = "GET_ALL_COMPANIES_REQUEST";
export const GET_ALL_COMPANIES_SUCCESS = "GET_ALL_COMPANIES_SUCCESS";
export const GET_ALL_COMPANIES_FAIL = "GET_ALL_COMPANIES_FAIL";

//GET_COMPANY
export const GET_COMPANY_REQUEST = "GET_COMPANY_REQUEST";
export const GET_COMPANY_SUCCESS = "GET_COMPANY_SUCCESS";
export const GET_COMPANY_FAIL = "GET_COMPANY_FAIL";

//GET_COMPANY_PUBLIC
export const GET_COMPANY_PUBLIC_REQUEST = "GET_COMPANY_PUBLIC_REQUEST";
export const GET_COMPANY_PUBLIC_SUCCESS = "GET_COMPANY_PUBLIC_SUCCESS";
export const GET_COMPANY_PUBLIC_FAIL = "GET_COMPANY_PUBLIC_FAIL";

//GET_JOB_PUBLIC
export const GET_JOB_PUBLIC_REQUEST = "GET_JOB_PUBLIC_REQUEST";
export const GET_JOB_PUBLIC_SUCCESS = "GET_JOB_PUBLIC_SUCCESS";
export const GET_JOB_PUBLIC_FAIL = "GET_JOB_PUBLIC_FAIL";

//DELETE_COMPANY
export const DELETE_COMPANY_REQUEST = "DELETE_COMPANY_REQUEST";
export const DELETE_COMPANY_SUCCESS = "DELETE_COMPANY_SUCCESS";
export const DELETE_COMPANY_FAIL = "DELETE_COMPANY_FAIL";

//CANDIDATE_APPLY
export const CANDIDATE_APPLY_REQUEST = "CANDIDATE_APPLY_REQUEST";
export const CANDIDATE_APPLY_SUCCESS = "CANDIDATE_APPLY_SUCCESS";
export const CANDIDATE_APPLY_FAIL = "CANDIDATE_APPLY_FAIL";

//ADD_CANDIDATE
export const ADD_CANDIDATE_REQUEST = "ADD_CANDIDATE_REQUEST";
export const ADD_CANDIDATE_SUCCESS = "ADD_CANDIDATE_SUCCESS";
export const ADD_CANDIDATE_FAIL = "ADD_CANDIDATE_FAIL";

//CANDIDATE_APPLY_SCREENING_ANSWER
export const CANDIDATE_APPLY_SCREENING_ANSWER_REQUEST =
  "CANDIDATE_APPLY_SCREENING_ANSWER_REQUEST";
export const CANDIDATE_APPLY_SCREENING_ANSWER_SUCCESS =
  "CANDIDATE_APPLY_SCREENING_ANSWER_SUCCESS";
export const CANDIDATE_APPLY_SCREENING_ANSWER_FAIL =
  "CANDIDATE_APPLY_SCREENING_ANSWER_FAIL";

//GET_ALL_CANDIDATES
export const GET_ALL_CANDIDATES_REQUEST = "GET_ALL_CANDIDATES_REQUEST";
export const GET_ALL_CANDIDATES_SUCCESS = "GET_ALL_CANDIDATES_SUCCESS";
export const GET_ALL_CANDIDATES_FAIL = "GET_ALL_CANDIDATES_FAIL";

//GET_CANDIDATE
export const GET_CANDIDATE_REQUEST = "GET_CANDIDATE_REQUEST";
export const GET_CANDIDATE_SUCCESS = "GET_CANDIDATE_SUCCESS";
export const GET_CANDIDATE_FAIL = "GET_CANDIDATE_FAIL";

//UPDATE_CANDIDATE_STATUS
export const UPDATE_CANDIDATE_STATUS_REQUEST =
  "UPDATE_CANDIDATE_STATUS_REQUEST";
export const UPDATE_CANDIDATE_STATUS_SUCCESS =
  "UPDATE_CANDIDATE_STATUS_SUCCESS";
export const UPDATE_CANDIDATE_STATUS_FAIL = "UPDATE_CANDIDATE_STATUS_FAIL";

//UPDATE_CANDIDATE_NOTES
export const UPDATE_CANDIDATE_NOTES_REQUEST = "UPDATE_CANDIDATE_NOTES_REQUEST";
export const UPDATE_CANDIDATE_NOTES_SUCCESS = "UPDATE_CANDIDATE_NOTES_SUCCESS";
export const UPDATE_CANDIDATE_NOTES_FAIL = "UPDATE_CANDIDATE_NOTES_FAIL";

//UPDATE_CANDIDATE_TALENTPOOL
export const UPDATE_CANDIDATE_TALENTPOOL_REQUEST =
  "UPDATE_CANDIDATE_TALENTPOOL_REQUEST";
export const UPDATE_CANDIDATE_TALENTPOOL_SUCCESS =
  "UPDATE_CANDIDATE_TALENTPOOL_SUCCESS";
export const UPDATE_CANDIDATE_TALENTPOOL_FAIL =
  "UPDATE_CANDIDATE_TALENTPOOL_FAIL";

//UPDATE_BULK_CANDIDATE_TALENTPOOL
export const UPDATE_BULK_CANDIDATE_TALENTPOOL_REQUEST =
  "UPDATE_BULK_CANDIDATE_TALENTPOOL_REQUEST";
export const UPDATE_BULK_CANDIDATE_TALENTPOOL_SUCCESS =
  "UPDATE_BULK_CANDIDATE_TALENTPOOL_SUCCESS";
export const UPDATE_BULK_CANDIDATE_TALENTPOOL_FAIL =
  "UPDATE_BULK_CANDIDATE_TALENTPOOL_FAIL";

//ARCHIVE_BULK_CANDIDATE
export const ARCHIVE_BULK_CANDIDATE_REQUEST = "ARCHIVE_BULK_CANDIDATE_REQUEST";
export const ARCHIVE_BULK_CANDIDATE_SUCCESS = "ARCHIVE_BULK_CANDIDATE_SUCCESS";
export const ARCHIVE_BULK_CANDIDATE_FAIL = "ARCHIVE_BULK_CANDIDATE_FAIL";

//GET_CANDIDATE_FROM_TALENTPOOL
export const GET_CANDIDATE_FROM_TALENTPOOL_REQUEST =
  "GET_CANDIDATE_FROM_TALENTPOOL_REQUEST";
export const GET_CANDIDATE_FROM_TALENTPOOL_SUCCESS =
  "GET_CANDIDATE_FROM_TALENTPOOL_SUCCESS";
export const GET_CANDIDATE_FROM_TALENTPOOL_FAIL =
  "GET_CANDIDATE_FROM_TALENTPOOL_FAIL";

//ASSIGN_JOB_TO_TALENTPOOL
export const ASSIGN_JOB_TO_TALENTPOOL_REQUEST =
  "ASSIGN_JOB_TO_TALENTPOOL_REQUEST";
export const ASSIGN_JOB_TO_TALENTPOOL_SUCCESS =
  "ASSIGN_JOB_TO_TALENTPOOL_SUCCESS";
export const ASSIGN_JOB_TO_TALENTPOOL_FAIL = "ASSIGN_JOB_TO_TALENTPOOL_FAIL";

//GET_ALL_RECRUIT_COMPANIES
export const GET_ALL_RECRUIT_COMPANIES_REQUEST =
  "GET_ALL_RECRUIT_COMPANIES_REQUEST";
export const GET_ALL_RECRUIT_COMPANIES_SUCCESS =
  "GET_ALL_RECRUIT_COMPANIES_SUCCESS";
export const GET_ALL_RECRUIT_COMPANIES_FAIL = "GET_ALL_RECRUIT_COMPANIES_FAIL";

//GET_ALL_STATUSES_TEMPLATES
export const GET_ALL_STATUSES_TEMPLATES_REQUEST =
  "GET_ALL_STATUSES_TEMPLATES_REQUEST";
export const GET_ALL_STATUSES_TEMPLATES_SUCCESS =
  "GET_ALL_STATUSES_TEMPLATES_SUCCESS";
export const GET_ALL_STATUSES_TEMPLATES_FAIL =
  "GET_ALL_STATUSES_TEMPLATES_FAIL";

//CREATE_STATUSES_TEMPLATE
export const CREATE_STATUSES_TEMPLATE_REQUEST =
  "CREATE_STATUSES_TEMPLATE_REQUEST";
export const CREATE_STATUSES_TEMPLATE_SUCCESS =
  "CREATE_STATUSES_TEMPLATE_SUCCESS";
export const CREATE_STATUSES_TEMPLATE_FAIL = "CREATE_STATUSES_TEMPLATE_FAIL";

//UPDATE_STATUSES_TEMPLATE
export const UPDATE_STATUSES_TEMPLATE_REQUEST =
  "UPDATE_STATUSES_TEMPLATE_REQUEST";
export const UPDATE_STATUSES_TEMPLATE_SUCCESS =
  "UPDATE_STATUSES_TEMPLATE_SUCCESS";
export const UPDATE_STATUSES_TEMPLATE_FAIL = "UPDATE_STATUSES_TEMPLATE_FAIL";

//DELETE_STATUSES_TEMPLATE
export const DELETE_STATUSES_TEMPLATE_REQUEST =
  "DELETE_STATUSES_TEMPLATE_REQUEST";
export const DELETE_STATUSES_TEMPLATE_SUCCESS =
  "DELETE_STATUSES_TEMPLATE_SUCCESS";
export const DELETE_STATUSES_TEMPLATE_FAIL = "DELETE_STATUSES_TEMPLATE_FAIL";

//UPDATE_TEMPLATE_ID_TO_JOB_AD_POST
export const UPDATE_TEMPLATE_ID_TO_JOB_AD_POST_REQUEST =
  "UPDATE_TEMPLATE_ID_TO_JOB_AD_POST_REQUEST";
export const UPDATE_TEMPLATE_ID_TO_JOB_AD_POST_SUCCESS =
  "UPDATE_TEMPLATE_ID_TO_JOB_AD_POST_SUCCESS";
export const UPDATE_TEMPLATE_ID_TO_JOB_AD_POST_FAIL =
  "UPDATE_TEMPLATE_ID_TO_JOB_AD_POST_FAIL";

//CREATE_EMAIL_TEMPLATE
export const CREATE_EMAIL_TEMPLATE_REQUEST = "CREATE_EMAIL_TEMPLATE_REQUEST";
export const CREATE_EMAIL_TEMPLATE_SUCCESS = "CREATE_EMAIL_TEMPLATE_SUCCESS";
export const CREATE_EMAIL_TEMPLATE_FAIL = "CREATE_EMAIL_TEMPLATE_FAIL";

//UPDATE_EMAIL_TEMPLATE
export const UPDATE_EMAIL_TEMPLATE_REQUEST = "UPDATE_EMAIL_TEMPLATE_REQUEST";
export const UPDATE_EMAIL_TEMPLATE_SUCCESS = "UPDATE_EMAIL_TEMPLATE_SUCCESS";
export const UPDATE_EMAIL_TEMPLATE_FAIL = "UPDATE_EMAIL_TEMPLATE_FAIL";

//GET_ALL_EMAIL_TEMPLATE
export const GET_ALL_EMAIL_TEMPLATE_REQUEST = "GET_ALL_EMAIL_TEMPLATE_REQUEST";
export const GET_ALL_EMAIL_TEMPLATE_SUCCESS = "GET_ALL_EMAIL_TEMPLATE_SUCCESS";
export const GET_ALL_EMAIL_TEMPLATE_FAIL = "GET_ALL_EMAIL_TEMPLATE_FAIL";

//DELETE_EMAIL_TEMPLATE
export const DELETE_EMAIL_TEMPLATE_REQUEST = "DELETE_EMAIL_TEMPLATE_REQUEST";
export const DELETE_EMAIL_TEMPLATE_SUCCESS = "DELETE_EMAIL_TEMPLATE_SUCCESS";
export const DELETE_EMAIL_TEMPLATE_FAIL = "DELETE_EMAIL_TEMPLATE_FAIL";

//Testing

//GET_ALL_ON_BOARDING_TEMPLATES
export const GET_ALL_ON_BOARDING_TEMPLATES_REQUEST =
  "GET_ALL_ON_BOARDING_TEMPLATES_REQUEST";
export const GET_ALL_ON_BOARDING_TEMPLATES_SUCCESS =
  "GET_ALL_ON_BOARDING_TEMPLATES_SUCCESS";
export const GET_ALL_ON_BOARDING_TEMPLATES_FAIL =
  "GET_ALL_ON_BOARDING_TEMPLATES_FAIL";

//CREATE_ON_BOARDING_TASKS
export const CREATE_ON_BOARDING_TASKS_REQUEST =
  "CREATE_ON_BOARDING_TASKS_REQUEST";
export const CREATE_ON_BOARDING_TASKS_SUCCESS =
  "CREATE_ON_BOARDING_TASKS_SUCCESS";
export const CREATE_ON_BOARDING_TASKS_FAIL = "CREATE_ON_BOARDING_TASKS_FAIL";

//CREATE_ON_BOARDING_STAGES
export const CREATE_ON_BOARDING_STAGES_REQUEST =
  "CREATE_ON_BOARDING_STAGES_REQUEST";
export const CREATE_ON_BOARDING_STAGES_SUCCESS =
  "CREATE_ON_BOARDING_STAGES_SUCCESS";
export const CREATE_ON_BOARDING_STAGES_FAIL = "CREATE_ON_BOARDING_STAGES_FAIL";

//GET_ON_BOARDING_TEMPLATE
export const GET_ON_BOARDING_TEMPLATE_REQUEST =
  "GET_ON_BOARDING_TEMPLATE_REQUEST";
export const GET_ON_BOARDING_TEMPLATE_SUCCESS =
  "GET_ON_BOARDING_TEMPLATE_SUCCESS";
export const GET_ON_BOARDING_TEMPLATE_FAIL = "GET_ON_BOARDING_TEMPLATE_FAIL";

//CREATE_ON_BOARDING_TEMPLATE
export const CREATE_ON_BOARDING_TEMPLATE_REQUEST =
  "CREATE_ON_BOARDING_TEMPLATE_REQUEST";
export const CREATE_ON_BOARDING_TEMPLATE_SUCCESS =
  "CREATE_ON_BOARDING_TEMPLATE_SUCCESS";
export const CREATE_ON_BOARDING_TEMPLATE_FAIL =
  "CREATE_ON_BOARDING_TEMPLATE_FAIL";

//ASSIGN_ON_BOARDING_TEMPLATE
export const ASSIGN_ON_BOARDING_TEMPLATE_REQUEST =
  "ASSIGN_ON_BOARDING_TEMPLATE_REQUEST";
export const ASSIGN_ON_BOARDING_TEMPLATE_SUCCESS =
  "ASSIGN_ON_BOARDING_TEMPLATE_SUCCESS";
export const ASSIGN_ON_BOARDING_TEMPLATE_FAIL =
  "ASSIGN_ON_BOARDING_TEMPLATE_FAIL";

//UPDATE_ON_BOARDING_TEMPLATE
export const UPDATE_ON_BOARDING_TEMPLATE_REQUEST =
  "UPDATE_ON_BOARDING_TEMPLATE_REQUEST";
export const UPDATE_ON_BOARDING_TEMPLATE_SUCCESS =
  "UPDATE_ON_BOARDING_TEMPLATE_SUCCESS";
export const UPDATE_ON_BOARDING_TEMPLATE_FAIL =
  "UPDATE_ON_BOARDING_TEMPLATE_FAIL";

//DELETE_ON_BOARDING_TEMPLATE
export const DELETE_ON_BOARDING_TEMPLATE_REQUEST =
  "DELETE_ON_BOARDING_TEMPLATE_REQUEST";
export const DELETE_ON_BOARDING_TEMPLATE_SUCCESS =
  "DELETE_ON_BOARDING_TEMPLATE_SUCCESS";
export const DELETE_ON_BOARDING_TEMPLATE_FAIL =
  "DELETE_ON_BOARDING_TEMPLATE_FAIL";

//CREATE_DOCUMENT_TEMPLATE
export const CREATE_MANDATORY_DOCUMENT_TEMPLATE_REQUEST =
  "CREATE_MANDATORY_DOCUMENT_TEMPLATE_REQUEST";
export const CREATE_MANDATORY_DOCUMENT_TEMPLATE_SUCCESS =
  "CREATE_MANDATORY_DOCUMENT_TEMPLATE_SUCCESS";
export const CREATE_MANDATORY_DOCUMENT_TEMPLATE_FAIL =
  "CREATE_MANDATORY_DOCUMENT_TEMPLATE_FAIL";

//CREATE_DOCUMENT_TEMPLATE
export const CREATE_DOCUMENT_TEMPLATE_REQUEST =
  "CREATE_DOCUMENT_TEMPLATE_REQUEST";
export const CREATE_DOCUMENT_TEMPLATE_SUCCESS =
  "CREATE_DOCUMENT_TEMPLATE_SUCCESS";
export const CREATE_DOCUMENT_TEMPLATE_FAIL = "CREATE_DOCUMENT_TEMPLATE_FAIL";

//UPDATE_DOCUMENT_TEMPLATE
export const UPDATE_DOCUMENT_TEMPLATE_REQUEST =
  "UPDATE_DOCUMENT_TEMPLATE_REQUEST";
export const UPDATE_DOCUMENT_TEMPLATE_SUCCESS =
  "UPDATE_DOCUMENT_TEMPLATE_SUCCESS";
export const UPDATE_DOCUMENT_TEMPLATE_FAIL = "UPDATE_DOCUMENT_TEMPLATE_FAIL";

//UPDATE_DOCUMENT_TYPE
export const UPDATE_DOCUMENT_STATUS_REQUEST = "UPDATE_DOCUMENT_STATUS_REQUEST";
export const UPDATE_DOCUMENT_STATUS_SUCCESS = "UPDATE_DOCUMENT_STATUS_SUCCESS";
export const UPDATE_DOCUMENT_STATUS_FAIL = "UPDATE_DOCUMENT_STATUS_FAIL";

//UPDATE_DOCUMENT_TYPE
export const UPDATE_DOCUMENT_TYPE_REQUEST = "UPDATE_DOCUMENT_TYPE_REQUEST";
export const UPDATE_DOCUMENT_TYPE_SUCCESS = "UPDATE_DOCUMENT_TYPE_SUCCESS";
export const UPDATE_DOCUMENT_TYPE_FAIL = "UPDATE_DOCUMENT_TYPE_FAIL";

//GET_ALL_DOCUMENT_TEMPLATE
export const GET_ALL_DOCUMENT_TEMPLATE_REQUEST =
  "GET_ALL_DOCUMENT_TEMPLATE_REQUEST";
export const GET_ALL_DOCUMENT_TEMPLATE_SUCCESS =
  "GET_ALL_DOCUMENT_TEMPLATE_SUCCESS";
export const GET_ALL_DOCUMENT_TEMPLATE_FAIL = "GET_ALL_DOCUMENT_TEMPLATE_FAIL";

//DELETE_DOCUMENT_TEMPLATE
export const DELETE_DOCUMENT_TEMPLATE_REQUEST =
  "DELETE_DOCUMENT_TEMPLATE_REQUEST";
export const DELETE_DOCUMENT_TEMPLATE_SUCCESS =
  "DELETE_DOCUMENT_TEMPLATE_SUCCESS";
export const DELETE_DOCUMENT_TEMPLATE_FAIL = "DELETE_DOCUMENT_TEMPLATE_FAIL";

//GET_EMPLOYEE_PDF
export const GET_EMPLOYEE_PDF_REQUEST = "GET_EMPLOYEE_PDF_REQUEST";
export const GET_EMPLOYEE_PDF_SUCCESS = "GET_EMPLOYEE_PDF_SUCCESS";
export const GET_EMPLOYEE_PDF_FAIL = "GET_EMPLOYEE_PDF_FAIL";
